<template>
  <div class="page-job-print section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-6-tablet is-5-desktop is-4-widescreen">

          <div class="box print-card has-text-centered">
            <div class="print-icon mb-4">
              <span class="icon is-large">
                <i class="fas fa-file-pdf"></i>
              </span>
            </div>

            <template v-if="!pdfGenerated && !hasError">
              <h1 class="title is-4">Generating Job PDF</h1>

              <p class="has-text-grey mb-5">
                Creating job summary #{{ $route.params.id }}.
              </p>

              <button class="button is-primary is-loading" disabled>
                Generating
              </button>
            </template>

            <template v-else-if="pdfGenerated">
              <h1 class="title is-4">PDF Ready</h1>

              <p class="has-text-grey mb-5">
                Job Summary #{{ $route.params.id }} has been generated.
              </p>

              <button
                class="button is-primary"
                type="button"
                @click="downloadPDF"
              >
                <span class="icon">
                  <i class="fas fa-download"></i>
                </span>
                <span>Download PDF</span>
              </button>
            </template>

            <template v-else>
              <h1 class="title is-4">PDF Failed</h1>

              <p class="has-text-grey mb-5">
                Something went wrong while generating the PDF.
              </p>

              <button
                class="button is-danger is-light"
                type="button"
                @click="printPDF"
              >
                Try Again
              </button>
            </template>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { toast } from 'bulma-toast'

export default {
  name: 'JobPrintView',

  data() {
    return {
      pdfGenerated: false,
      hasError: false,
      filename: ''
    }
  },

  mounted() {
    document.title = 'Job Print | SCE Electrical'
    this.printPDF()
  },

  methods: {
    showToast(message, type = 'is-danger') {
      toast({
        message,
        type,
        dismissible: true,
        pauseOnHover: true,
        duration: 2000,
        position: 'bottom-right',
      })
    },

    async printPDF() {
      this.$store.commit('setIsLoading', true)

      this.pdfGenerated = false
      this.hasError = false

      try {
        await axios.get(`/api/v1/print/${this.$route.params.id}`)

        this.filename = `Job Summary #${this.$route.params.id}.pdf`
        this.pdfGenerated = true
      } catch (error) {
        console.log(error)

        this.hasError = true
        this.showToast('Something went wrong. Please try again.')
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },

    async downloadPDF() {
      try {
        const response = await axios.get(
          `/api/v1/print/${this.$route.params.id}/download`,
          {
            responseType: 'blob'
          }
        )

        const blob = new Blob([response.data], {
          type: 'application/pdf'
        })

        const fileURL = URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = fileURL
        a.download = this.filename
        a.click()

        URL.revokeObjectURL(fileURL)
      } catch (error) {
        console.error('Error loading file:', error)
        this.showToast('Could not download PDF. Please try again.')
      }
    }
  }
}
</script>

<style scoped>
.page-job-print {
  min-height: 100%;
}

.print-card {
  border-radius: 14px;
  padding: 2.5rem 2rem;
}

.print-icon {
  width: 72px;
  height: 72px;
  margin-inline: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 999px;
  background: #f5f5f5;
  color: #cc0f35;
}

.print-icon .icon {
  font-size: 2rem;
}
</style>